module.exports = __webpack_public_path__ + "select-arrow.1dd68534.svg";